import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/student/laba.png'
import _imports_1 from '@/assets/student/zhuyishixiang.png'
import _imports_2 from '@/assets/student/homepage/lock.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-649381d0")

_pushScopeId("data-v-649381d0")
const _hoisted_1 = { class: "resourceDownload content" }
const _hoisted_2 = { class: "info flex justify-between align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "msg" }, "初次实验或实验仍未开始，请在此处下载相应安装包", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "zhuyi" }, "注意事项", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "pop-top flex align-items-center" }, [
  /*#__PURE__*/_createVNode("div", { class: "title" }, "注意事项"),
  /*#__PURE__*/_createVNode("img", {
    class: "pop-img ml12 mt4 mb4",
    src: _imports_0
  })
], -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", {
  class: "pop-main",
  style: {"width":"327px"}
}, [
  /*#__PURE__*/_createVNode("span", { class: "word-wrap" }, "安装时请关闭杀毒软件若被防火墙拦截，选择仍要运行")
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  class: "img",
  src: _imports_1
}, null, -1)
const _hoisted_8 = { class: "rotation" }
const _hoisted_9 = { class: "card-info flex justify-between align-items-center" }
const _hoisted_10 = { class: "ci-left" }
const _hoisted_11 = {
  key: 0,
  class: "lock"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("img", {
  width: "25",
  height: "25",
  src: _imports_2
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("点击下载")
const _hoisted_14 = /*#__PURE__*/_createVNode("span", null, "可以在上面区域使用鼠标滚轮进行横向滚动", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "mouse mt32" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_a_popover = _resolveComponent("a-popover")
  const _component_VerticalAlignBottomOutlined = _resolveComponent("VerticalAlignBottomOutlined")
  const _component_a_tooltip = _resolveComponent("a-tooltip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode(_component_a_popover, {
        placement: "bottomLeft",
        key: "info"
      }, {
        title: _withId(() => [
          _hoisted_5
        ]),
        content: _withId(() => [
          _hoisted_6
        ]),
        default: _withId(() => [
          _hoisted_7
        ]),
        _: 1
      })
    ]),
    _createVNode("div", _hoisted_8, [
      _createVNode("div", {
        class: "cardListVue flex flex-column flex-warp",
        "data-source": _ctx.dataList,
        id: "cardListVue"
      }, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataList, (record) => {
          return (_openBlock(), _createBlock("div", {
            class: "card",
            key: record.uuid,
            style: `background-image:url(${record.imgSrc})`
          }, [
            _createVNode(_component_a_tooltip, {
              title: record.resourceData?.introduce
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_9, [
                  _createVNode("div", _hoisted_10, _toDisplayString(record.title), 1),
                  (record.resourceData?.isUnLock)
                    ? (_openBlock(), _createBlock("div", _hoisted_11, [
                        _hoisted_12
                      ]))
                    : (_openBlock(), _createBlock("div", {
                        key: 1,
                        class: "ci-btn flex align-items-center justify-center pointer",
                        onClick: ($event: any) => (_ctx.handleClick(record))
                      }, [
                        _hoisted_13,
                        _createVNode(_component_VerticalAlignBottomOutlined)
                      ], 8, ["onClick"]))
                ])
              ]),
              _: 2
            }, 1032, ["title"])
          ], 4))
        }), 128))
      ], 8, ["data-source"])
    ]),
    _createVNode(_component_a_popover, null, {
      content: _withId(() => [
        _hoisted_14
      ]),
      default: _withId(() => [
        _hoisted_15
      ]),
      _: 1
    })
  ]))
})